import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify.js' // ← import ที่คุณ export ไว้
import './plugins'
import Highcharts from 'highcharts'
import HighchartsVue from 'highcharts-vue';
import 'highcharts/modules/exporting'
import 'highcharts/modules/export-data'
import 'highcharts/modules/full-screen'

Vue.config.productionTip = false
Vue.use(HighchartsVue, {Highcharts})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')